const locales = TheApp.Env.LocaleListShort;
const localeCurr = TheApp.Env.LocaleShort;
const routes = TheApp.Routes;

export default class LocaleSwitch {
    _archProjectsSlugs = ["projects", "proyectos", "projets", "projetos", "projekte"];

    constructor({
        container,
        btn,
        list,
        onOpen = null,
        onClose = null, 
    }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._routeCurr = this.getCurrentRoute();

        this._open = false;
        this._btn?.addEventListener("click", (e) => {
            e.stopPropagation();
            this.onBtnClick();
        });
        this._container?.addEventListener("click", this.closeSwitch.bind(this));
        this._list?.addEventListener("click", (e) => e.stopPropagation());
        window.addEventListener("keydown", (e) => e.key === "Escape" && this.closeSwitch());        
    }

    onBtnClick() {
        this._open ? this.closeSwitch() : this.openSwitch();
    }

    openSwitch() {
        this._container.classList.remove("is-hidden");
        this._open = true;
    }

    closeSwitch() {
        if (!this._container.classList.contains("is-hidden"))
            this._container.classList.add("is-hidden");

        this._open = false;
    }

    render() {
        if (locales) locales.push("it");

        locales.forEach((l) => {
            const li = document.createElement("li");
            const a = document.createElement("a");
            li.classList.add("locale-voice");

            a.href = `/${l}`;

            if (l !== "it") {
                a.href +=
                    this._routeCurr[1][l]
                        ? `/${this._routeCurr[1][l]}`
                        : '';
            } else {
                a.target = "_blank";
            }

            a.textContent = l;

            li.appendChild(a);
            this._list?.appendChild(li);
        });
    }

    getCurrentRoute() {
        const pathname = window.location.pathname.split("/");
        const routename = pathname[2];        
        let route = Object.entries(routes).find(r => r[1][localeCurr] === routename);

        return route ?? ['', ''];
    }
}